import { cn } from "@/lib/utils";

type LanguageCode = "nb-NO" | "en";

interface LanguageFlagProps {
	language: LanguageCode;
	className?: string;
}

export const LanguageFlag = ({ language, className }: LanguageFlagProps) => {
	const flagClassName = cn(
		"inline-block h-3.5 w-5 shrink-0 overflow-hidden rounded-[2px] ring-1 ring-black/15 dark:ring-white/20",
		className
	);

	if (language === "nb-NO") {
		return <NorwayFlag className={flagClassName} />;
	}

	return <UnitedKingdomFlag className={flagClassName} />;
};

interface LanguageOptionLabelProps {
	language: LanguageCode;
	label: string;
}

export const LanguageOptionLabel = ({
	language,
	label,
}: LanguageOptionLabelProps) => (
	<span className="inline-flex items-center gap-2">
		<LanguageFlag language={language} />
		<span>{label}</span>
	</span>
);

const NorwayFlag = ({ className }: { className?: string }) => (
	<svg
		viewBox="0 0 22 16"
		className={className}
		aria-hidden="true"
		focusable="false"
	>
		<rect width="22" height="16" fill="#BA0C2F" />
		<rect x="6" width="4" height="16" fill="#fff" />
		<rect y="6" width="22" height="4" fill="#fff" />
		<rect x="7" width="2" height="16" fill="#00205B" />
		<rect y="7" width="22" height="2" fill="#00205B" />
	</svg>
);

const UnitedKingdomFlag = ({ className }: { className?: string }) => (
	<svg
		viewBox="0 0 60 30"
		className={className}
		aria-hidden="true"
		focusable="false"
	>
		<rect width="60" height="30" fill="#012169" />
		<path d="M0 0l60 30M60 0L0 30" stroke="#fff" strokeWidth="10" />
		<path d="M0 0l60 30M60 0L0 30" stroke="#C8102E" strokeWidth="4" />
		<rect x="25" width="10" height="30" fill="#fff" />
		<rect y="10" width="60" height="10" fill="#fff" />
		<rect x="27" width="6" height="30" fill="#C8102E" />
		<rect y="12" width="60" height="6" fill="#C8102E" />
	</svg>
);
